import React from 'react';
import Nav from '../components/Nav';

function Order() {
  return (
    <>
      <Nav />
      <div className="container mx-auto  bg-gray-50 text-gray-700 pb-20">
        <section className="relative block h-[500px]">
          <img
            src="banner.png"
            className="absolute top-0 w-full h-full bg-center bg-cover"
            alt=""
          />

          <span
            id="blackOverlay"
            className="w-full h-full absolute opacity-20 bg-black"
          ></span>
        </section>

        <section className="bg-gray-100">
          <div className="container mx-auto px-4 ">
            <div className="relative flex flex-col min-w-0 break-words bg-gray-50 w-full mb-6 shadow-xl rounded-lg -mt-64">
              <div className="container mx-auto">
                <div className="py-10 container mx-auto mb-20 sm:mx-auto text-justify bg-gray-100 rounded-md p-8">
                  <div className="flex flex-col justify-between lg:flex-row">
                    <a
                      class="inline-block px-6 py-2.5 bg-yellow-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                      data-bs-toggle="collapse"
                      href="#personalInformation"
                      role="button"
                      aria-expanded="false"
                      aria-controls="personalInformation"
                    >
                      Personal Information
                    </a>
                    <a
                      class="inline-block px-6 py-2.5 bg-yellow-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                      data-bs-toggle="collapse"
                      href="#shipmentInformation"
                      role="button"
                      aria-expanded="false"
                      aria-controls="shipmentInformation"
                    >
                      Shipment Information
                    </a>
                    <a
                      class="inline-block px-6 py-2.5 bg-yellow-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                      data-bs-toggle="collapse"
                      href="#paymentInformation"
                      role="button"
                      aria-expanded="false"
                      aria-controls="paymentInformation"
                    >
                      Payment Information
                    </a>
                  </div>
                  <div>
                    <div
                      class="collapse mt-4 w-full h-full"
                      id="personalInformation"
                      // style={{ maxWidth: '500px' }}
                    >
                      <div className="max-w-3xl mx-auto bg-gray-100 shadow-lg p-10 rounded-lg">
                        <form className="flex flex-col space-y-2 py-4 ">
                          <div className="flex flex-col justify-center items-center">
                            <h1 className="text-4xl font-bold text-yellow-700 text-center">
                              Personal Information
                            </h1>
                          </div>
                          <input
                            type="text"
                            required
                            placeholder="Fullname eg John Doe"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <input
                            required
                            type="email"
                            placeholder="Email eg John@doe.com"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <input
                            required
                            type="number"
                            placeholder="Number (+233-540-000-000)"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />

                          <textarea
                            required
                            cols="3"
                            type="text"
                            placeholder="Address"
                            className="px-10  outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <button className="mt-2 px-8 py-2 text-lg text-white bg-yellow-700 rounded-lg hover:bg-yellow-700 active:bg-yellow-300 focus:ring-1 ring-yellow-900">
                            Add / Update
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      class="collapse mt-4 w-full h-full"
                      id="shipmentInformation"
                      // style={{ maxWidth: '500px' }}
                    >
                      <div className="max-w-3xl mx-auto bg-gray-100 shadow-lg p-10 rounded-lg">
                        <form className="flex flex-col space-y-2 py-4 ">
                          <div className="flex flex-col justify-center items-center">
                            <h1 className="text-4xl font-bold text-yellow-700 text-center">
                              Shipment Address
                            </h1>
                          </div>
                          <input
                            type="text"
                            required
                            placeholder="Country"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <input
                            required
                            type="text"
                            placeholder="city"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <input
                            required
                            type="number"
                            placeholder="zip code"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />

                          <textarea
                            required
                            cols="3"
                            type="text"
                            placeholder="other address or street"
                            className="px-10  outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <button className="mt-2 px-8 py-2 text-lg text-white bg-yellow-700 rounded-lg hover:bg-yellow-700 active:bg-yellow-300 focus:ring-1 ring-yellow-900">
                            Add / Update
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      class="collapse mt-4 w-full h-full"
                      id="paymentInformation"
                    >
                      <div className="max-w-3xl mx-auto bg-gray-100 shadow-lg p-10 rounded-lg">
                        <form className="flex flex-col space-y-2 py-4 ">
                          <div className="flex flex-col justify-center items-center">
                            <h1 className="text-4xl font-bold text-yellow-700 text-center">
                              Choose Your Mode of Pyament
                            </h1>
                          </div>
                          <label className="font-bold text-lg text-yellow-800 uppercase">
                            Mobile Money
                          </label>
                          <input
                            type="number"
                            required
                            placeholder="mobile number eg."
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <label className="font-bold text-lg text-yellow-800 uppercase">
                            Paypal
                          </label>

                          <input
                            required
                            type="number"
                            placeholder="card number eg. (938-540-000-000)"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />
                          <label className="font-bold text-lg text-yellow-800 uppercase">
                            visa Card
                          </label>

                          <input
                            required
                            type="number"
                            placeholder="card number eg. (389-540-000-000)"
                            className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                          />

                          <button className="mt-2 px-8 py-2 text-lg text-white bg-yellow-700 rounded-lg hover:bg-yellow-700 active:bg-yellow-300 focus:ring-1 ring-yellow-900">
                            Proccees To pay
                          </button>
                        </form>
                      </div>
                    </div>
                    <div className="max-w-xl mx-auto">
                      <h1 className="text-4xl uppercase mt-10 font-bold text-yellow-700 text-center">
                        Things to Know
                      </h1>
                      loremNulla pariatur deserunt dolore est enim sit anim aute
                      adipisicing ipsum elit quis nisi. Irure pariatur fugiat id
                      minim ullamco mollit fugiat exercitation adipisicing ad
                      duis irure sint. Id ipsum aliquip eiusmod incididunt ex.
                      Occaecat Lorem aliqua voluptate quis proident. Cillum qui
                      magna irure do culpa aliquip cupidatat id tempor sunt non
                      officia. Dolor ipsum nulla dolor non et consectetur
                      excepteur labore. Veniam ut tempor sit Lorem magna est
                      anim voluptate excepteur.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Order;
